module.exports = __webpack_public_path__ + "static/media/whatsapp2.f19392dc.svg";